import { connect } from 'react-redux';
import { push as pushAction } from 'react-router-redux';
import Program from './components/Program';
import { trackSelect, loadProgram } from './actions/programActions';

export const mapStateToProps = state => ({
    talksById: state.program.talksById,
    timeSlotsById: state.program.timeSlotsById,
    speakersById: state.speakers.speakersById,
    selectedTrack: state.program.selectedTrack,
    fetchingProgram: state.program.fetchingProgram
});

export const mapActionCreators = {
    pushAction,
    trackSelect,
    loadProgram
};

export default connect(
    mapStateToProps,
    mapActionCreators
)(Program);
